import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added for navigation
import '../../assets/styles/Logistics.css';

function Logistics() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Logistics</title>
        <meta name="description" content="Comprehensive logistics solutions customized to your business." />
      </Helmet>
      <section className="logistics-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="logistics-image img-fluid rounded"
                alt="Logistics Services"
              />
            </div>
            <div className="col-md-6">
              <h2 className="service-title fw-bold mb-4">Logistics Services</h2>
              <p className="service-description">
                Our tailored logistics services streamline your supply chain, enhancing efficiency and reducing costs. From warehousing to distribution, RFF Cargo offers end-to-end solutions customized to your business needs, ensuring seamless operations and reliable delivery across global markets.
              </p>
              <Link to="/contact" className="btn btn-contact-us mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Logistics;